import { type ConsentPreferences,getConsent, onConsentChange } from './consent';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Initialize Google Consent Mode v2 with default denied state.
 * Must be called BEFORE any Google scripts are loaded.
 */
export function initConsentMode(): void {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments as unknown as Record<string, unknown>);
  };

  // Set defaults based on stored preferences (or denied if no consent yet)
  const stored = getConsent();
  const analyticsGranted = stored?.statistics ? 'granted' : 'denied';
  const marketingGranted = stored?.marketing ? 'granted' : 'denied';

  window.gtag('consent', 'default', {
    analytics_storage: analyticsGranted,
    ad_storage: marketingGranted,
    ad_user_data: marketingGranted,
    ad_personalization: marketingGranted,
    wait_for_update: 500,
  });

  // Listen for consent changes and update
  onConsentChange((prefs: ConsentPreferences) => {
    window.gtag('consent', 'update', {
      analytics_storage: prefs.statistics ? 'granted' : 'denied',
      ad_storage: prefs.marketing ? 'granted' : 'denied',
      ad_user_data: prefs.marketing ? 'granted' : 'denied',
      ad_personalization: prefs.marketing ? 'granted' : 'denied',
    });
  });
}
